<!-- 入会/续会 -->
<template >
    <div class="msph-contract-form">
        <el-dialog
            :visible.sync="visible"
            :title="type === 1 ? $t('Member.admission_contract') : $t('Member.renewal_contract')"
            left>
            <div class="msph-dialog-title bg-gray mg-10">
                <p class="msph-dialog-title-p">
                    {{ $t('Common.name') }}：{{ client.clientName }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.phone') }}：{{ client.clientPhone }}
                </p>
                <div v-if="type === 2 || isDeposit">
                    <p class="msph-dialog-title-p">
                        {{ $t('Common.card_number') }}：{{ client.cardNum }}
                    </p>
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.has_zhong') }}：{{ client.cardNames }}
                    </p>
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.start_end_date') }}：{{ client.validity }}
                    </p>
                </div>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="120px"
                label-suffix=":">
                <el-form-item
                    :label="type === 1 ? $t('Member.open_card_store') : $t('Member.xu_store')"
                    prop="storeId">
                    <el-select
                        @change="selectStore"
                        v-model="form.storeId"
                        :placeholder="$t('Common.all_store2')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="index"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Member.saler')" prop="salesStaffId">
                    <el-select
                        @change="searchText = null"
                        v-model="form.salesStaffId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full" clearable>
                        <input
                            class="search-input-all"
                            type="text"
                            v-model="searchText"/>
                        <el-option
                            v-for="(item, index) in filterList"
                            :key="index"
                            :label="item.nickname"
                            :value="Number(item.id)"
                            :disabled="item.id === 'no'" />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Contract.card_name')" prop="cardId">
                    <el-select
                        @change="fetchCardInfo"
                        v-model="form.cardId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full"
                        clearable>
                        <input
                            class="search-input-all"
                            type="text"
                            v-model="searchCard"/>
                        <el-option
                            v-for="(item, index) in filterCard"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            :disabled="item.id === 'no'" />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Card.image')" v-if="cardInfo.image">
                    <div class="contract_card_show">
                        <img :src="cardInfo.image" >
                    </div>
                </el-form-item>
                <el-form-item prop="supportStoreType"
                    :label="$t('Contract.support_store')"
                    v-if="cardInfo.supportStoreDesc">
                    {{ cardInfo.supportStoreDesc }}
                </el-form-item>
                <div v-if="cardInfo.supportStoreType === 2" class="box-1e">
                    <div>
                        <el-checkbox
                            class="label-name"
                            :indeterminate="isSupportIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange"
                        >{{ $t('Course.check_all') }}</el-checkbox>
                        <div class="box-a">
                            <el-checkbox-group
                                v-model="form.supportStoreIds"
                                @change="handleCheckedSupportStoresChange">
                                <el-checkbox
                                    v-for="(item, index) in supportStores"
                                    :label="item.storeId"
                                    :key="index"
                                >{{ item.storeName }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
                <el-form-item
                    prop="activeCardWayCode"
                    :label="$t('Member.open_card_method')">
                    <el-select
                        @change="restActiveFild"
                        v-model="form.activeCardWayCode"
                        :placeholder="$t('Member.open_card_placeholder')"
                        class="w-full"
                        :disabled="type === 2"
                        clearable>
                        <el-option :label="$t('Card.Way.day')" :value="1"/>
                        <el-option :label="$t('Card.Way.enter')" :value="2"/>
                        <el-option :label="$t('Card.Way.date')" :value="3" />
                    </el-select>
                </el-form-item>
                <el-form-item prop="daysToActive">
                    <div v-if="Number(cardInfo.giftCredit) > 0" class="mb-2">
                        <span style="font-size: 12px">{{ $t('Card.gift') }}: </span>
                        <el-input
                            type="number"
                            style="width: 50px;"
                            v-model="form.giftCredit"
                            :max="cardInfo.giftCredit"
                        />
                        <span style="font-size: 12px">
                             ≤ {{ cardInfo.giftCredit }}
                             {{ Number(cardInfo.cardType) === 2 ? $t('Week.ci') : $t('Week.day2') }}
                        </span>
                    </div>
                    <div v-if="form.activeCardWayCode === 2 && type === 1">
                        <span style="font-size: 12px"> {{ $t('Week.if') }} </span>
                        <el-input
                            type="number"
                            style="width: 50px;"
                            v-model="form.daysToActive"/>
                        <span style="font-size: 12px"> {{ $t('Card.automatic_open') }}</span>
                        <span
                            style="font-size: 12px"
                            v-if="form.daysToActive"
                        >（{{ $t('Card.last_automatic') }}{{ calLatestTime }}）</span>
                    </div>
                </el-form-item>
                <el-form-item
                    prop="startAt"
                    :label="$t('Contract.start_time')"
                    v-if="form.activeCardWayCode === 3">
                    <el-date-picker
                        v-model="form.startAt"
                        type="date"
                        style="width:180px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"/>
                    <p
                        style="font-size: 12px;"
                        class="mb-0"
                        v-if="form.startAt && cardInfo.validPeriod">
                        {{ $t('Contract.end_time') }}:{{ calContractEndAt }}
                    </p>
                </el-form-item>
                <!-- 身份证号：prop="certNum"  -->
                <el-form-item :label="$t('Sell.identity_number')" class="fitness-redItem">
                    <el-input
                        type="text"
                        v-model="form.certNum"
                        :placeholder="$t('Fill.identity_number_placeholder')"/>
                </el-form-item>
                <template v-if="type === 1">
                    <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                    <el-form-item
                        prop="toBindCardPhysicalId"
                        :label="$t('Common.bind_physical')"
                        label-width="130px">
                        <el-input
                            type="text"
                            v-model="form.toBindCardPhysicalId"
                            :placeholder="$t('Client.click_duka')"
                        />
                    </el-form-item>
                    <el-form-item prop="toBindCardNum" :label="$t('Common.card_number')">
                        <!-- <el-input type="text" v-model="form.toBindCardNum" placeholder="请输入会员卡号"/> -->
                        <el-select
                            v-model="form.toBindCardNum"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Common.card_number_placeholder')"
                            :remote-method="fetchCardNum"
                            @change="selectCard">
                            <el-option
                                v-for="item in memberCards"
                                :key="item.id"
                                :label="item.cardNumber"
                                :value="item.cardNumber">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="recommendClientId" :label="$t('Client.Add.referrer')">
                        <el-select
                            style="width: 100%;"
                            v-model="form.recommendClientId"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Fill.search_client')"
                            :remote-method="searchEnterFun"
                            :loading="loading">
                            <el-option
                                v-for="(item, index) in clients"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="推荐码" v-if="type===1">
                        <el-input placeholder="请输入推荐码"/>
                    </el-form-item> -->
                </template>
                <el-form-item prop="remark" :label="$t('Common.remark')">
                    <el-input type="textarea" v-model="form.remark"/>
                </el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item prop="contractNum" :label="$t('Contract.number')">
                    <el-input type="text" v-model="form.contractNum" class="mr-2" style="width:200px"/>
                    <el-button
                        type="success"
                        v-if="autoContractNum"
                        @click="getAutoContractNum"
                    >{{ $t('Common.zidong') }}</el-button>
                </el-form-item>
                <el-form-item prop="baseAmt" :label="$t('Charge.base_amt')" >
                    <el-input type="number" style="width: 150px" v-model="form.baseAmt"/>
                    <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item prop="discountAmt" :label="$t('Charge.discounted_price')">
                    <el-input type="number" style="width: 150px" v-model="form.discountAmt"/>
                    <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.finally_money')">
                    {{ calPrice ? calPrice : form.baseAmt }}
                    <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.contract_deduction')" v-if="isDeposit">
                    <span>{{ client.prepayAmt }} {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.amount_to_be_paid')" v-if="isDeposit">
                    <span>
                        {{ computedMoney }} {{ $t('Reception.Fifth.yuan') }}
                    </span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button
                    :disabled="isDeposit && form.baseAmt && form.baseAmt - Number(client.prepayAmt) < 0
                    || isDeposit && form.baseAmt && form.discountAmt
                    && form.baseAmt - Number(client.prepayAmt) - form.discountAmt < 0"
                    @click="submit"
                    type="primary">
                    {{ $t('Common.next_step') }}
                </el-button>
            </div>
        </el-dialog>
        <pay-form ref="pay" :contract="'potential'" @refreshData="refreshData" />
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';
import filterRole from '@/mixins/filterRole.js';
import timeMixin from '@/mixins/timeMixin.js';

export default {
    // type 1 入会，2 续会
    props: ['type', 'isDeposit'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        PayForm,
    },
    mixins: [filterRole, timeMixin],
    data() {
        return {
            latestTime: '',
            autoContractNum: false,
            checkAll: false,
            isSupportIndeterminate: false,
            searchText: '',
            cardInfo: {},
            clients: [],
            client: {},
            staffs: [],
            stores: [],
            supportStores: [],
            cards: [],
            loading: false,
            visible: false,
            finalPrice: 0,
            form: {
                supportStoreIds: [],
                baseAmt: null,
            },
            rules: {
                storeId: {
                    required: true, message: this.$t('Common.store_placeholder'), trigger: 'blur', type: 'number',
                },
                supportStoreIds: {
                    required: true,
                    message: this.$t('Choose.support_store'),
                    trigger: 'blur',
                },
                salesStaffId: {
                    required: true,
                    message: this.$t('Choose.saler2'),
                    trigger: 'blur',
                    type: 'number',
                },
                startAt: { required: true, message: this.$t('Contract.start_date') },
                contractNum: { required: true, message: this.$t('Contract.fill_number') },
                supportStoreType: { required: true, message: this.$t('Choose.support_store') },
                baseAmt: { required: true, message: this.$t('Fill.base_amt'), trigger: 'blur' },
                cardId: { required: true, message: this.$t('Choose.card_zhong'), trigger: 'blur' },
                activeCardWayCode: {
                    required: true,
                    message: this.$t('Member.open_card_placeholder'),
                    trigger: 'blur',
                },
                certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
            },
            memberCards: [],
            prepayContractNum: null,
            searchCard: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    computed: {
        computedMoney: function () {
            let money;
            const {form} = this;
            if (form.baseAmt && !form.discountAmt) money = form.baseAmt - Number(this.client.prepayAmt);
            else if (form.baseAmt && form.discountAmt) {
                money = form.baseAmt - Number(this.client.prepayAmt) - form.discountAmt;
            }
            return money;
        },
        calPrice: function () {
            let money;
            if (!this.isDeposit) money = Number(this.form.baseAmt) - Number(this.form.discountAmt);
            else if (this.isDeposit && this.form.discountAmt) {
                money = Number(this.form.baseAmt) - Number(this.form.discountAmt) - Number(this.client.prepayAmt);
            }
            if (money < 0) money = '0';
            return money;
        },
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterCard() {
            if (!this.searchCard) return this.cards;
            const arr = this.cards.filter(item =>
                item.name.toLowerCase().indexOf(this.searchCard.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', name: this.$t('Common.data_not_found')}];
        },
        calLatestTime: function () {
            const date = this.AddWeeks(new Date(), this.form.daysToActive);
            return `${date.getFullYear()}-${Number(date.getMonth() + 1)}-${date.getDate()}`;
        },
        calContractEndAt: function () {
            const date = new Date(this.form.startAt);
            date.setDate(date.getDate() + this.cardInfo.validPeriod);
            return `${date.getFullYear()}-${Number(date.getMonth() + 1)}-${date.getDate()}`;
        },
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.form = {
                supportStoreIds: [],
                baseAmt: null,
            };
            this.cardInfo = {};
            this.$refs.form.resetFields();
        },
        open(data, type, num) {
            if (this.isDeposit) this.prepayContractNum = num;
            this.fetchData(data, type, num);
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchData(data, type, num) {
            API.get(`client/${data}/init-contract`, {
                params: {
                    type: type || this.type,
                    prepayContractNum: num,
                },
            }).then(res => {
                this.client = res;
                this.fetchStore();
                if (this.type === 2) {
                    this.$set(this.form, 'activeCardWayCode', 3);
                    const end = new Date(res.validity.split(' ')[2]);
                    this.$set(this.form, 'startAt', new Date((end / 1000 + 86400) * 1000));
                }
                this.visible = true;
                if (res.certNum) this.form.certNum = res.certNum;
            });
            this.finalPrice = Number(data.baseAmt) - Number(data.discountAmt);
        },
        async fetchSalers() {
            const ids = [5, 6];
            const {storeId} = this.form;
            this.staffs = await this.filterRole(null, ids, storeId, null, 'work');
        },
        selectStore() {
            this.$set(this.form, 'salesStaffId', null);
            this.$set(this.form, 'cardId', null);
            this.fetchSalers();
            this.fetchCard();
            this.stores.forEach(el => {
                if (el.id === this.form.storeId) {
                    this.autoContractNum = el.autoContractNum;
                }
            });
        },
        fetchCard() {
            this.loading = true;
            API.get(`member-card/list?storeId=${this.form.storeId}`)
                .then(res => {
                    this.cards = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        searchEnterFun(val) {
            this.loading = true;
            API.get('client/search', {
                params: {
                    keyword: val,
                },
            }).then(res => {
                this.clients = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            this.form.type = this.type;
            this.form.clientId = this.client.clientId;
            this.form.toBindCardPhysicalId = this.form.toBindCardPhysicalId ? this.form.toBindCardPhysicalId : '';
            this.form.toBindCardNum = this.form.toBindCardNum ? this.form.toBindCardNum : '';
            this.form.giftCredit = this.form.giftCredit ? this.form.giftCredit : '';
            this.form.remark = this.form.remark ? this.form.remark : '';
            if (this.isDeposit) this.form.prepayContractNum = this.prepayContractNum;
            API.post('contract/mshp', this.form)
                .then(() => {
                    this.visible = false;
                    this.$refs.pay.open(this.form.contractNum);
                    this.form = {};
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        fetchCardInfo(val) {
            this.searchCard = null;
            this.loading = true;
            API.get(`member-card/${val}/card-info`).then(res => {
                this.cardInfo = res;
                // res.cardType 2-次卡类型,3-期限类型
                if (Number(res.supportStoreType) === 2) this.supportStores = res.supportStores;
                this.form.supportStoreType = res.supportStoreType;
                this.form.baseAmt = res.basePrice;
            }).finally(() => {
                this.loading = false;
            });
        },
        handleCheckAllChange(val) {
            this.form.supportStoreIds = val ? this.supportStores.map(el => el.storeId) : [];
            this.isSupportIndeterminate = false;
        },
        handleCheckedSupportStoresChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.supportStores.length;
            this.isSupportIndeterminate = checkedCount > 0 && checkedCount < this.supportStores.length;
        },
        getAutoContractNum() {
            this.loading = true;
            API.get(`store/${this.form.storeId}/gen-contract-num`).then(res => {
                this.$set(this.form, 'contractNum', res);
            }).finally(() => {
                this.loading = false;
            });
        },
        restActiveFild() {
            this.$set(this.form, 'daysToActive', null);
            // this.$set(this.form, 'giftCredit', this.cardInfo.giftCredit);
            this.$set(this.form, 'startAt', null);
        },
        fetchCardNum(val = '') {
            API.get('card-number-setting/pages', {
                params: {
                    keyword: val,
                    storeIds: this.form.storeId,
                    status: 1,
                },
            }).then(res => {
                this.memberCards = res.content;
            });
        },
        selectCard() {
            const item = this.memberCards.find(el => el.cardNumber === this.form.toBindCardNum);
            this.form.toBindCardPhysicalId = item.physicalId;
        },
    },
};
</script>

<style lang="scss">
.msph-contract-form {
    .el-dialog {
        // left: 50%;
        // top: 50%;
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        width: 600px;
        // transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__body {
        height: 50vh;
        overflow: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .msph-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .msph-dialog-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .box-a {
        margin-left: 20px;
        padding: 10px 15px;
        background: #fff!important;
        min-height: 70px!important;
        overflow: scroll;
    }
    .box-1e {
        position: relative;
        left: 120px;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 75%;
        min-height: 150px;
    }
    .contract_card_show {
        display: block;
        overflow: hidden;
        width: 160px;
        height: 100px;
        border-radius: 5px;
    }
}
</style>
